import * as React from "react";
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {MissedPaymentForm} from "./MissedPaymentForm";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {Navigate} from "react-router-dom";
import {AnnualPolicyInfo, AnnualPolicyPremiumTypeEnum} from "@ferry/journey-services";
import {FalconNavigatorHeader, Footer} from "@ferry/portal-core";
import {lazyInject} from "@athena-portal/core";
import {Types} from "../../../../../Types";
import type {ICustomerPortalService} from "../../../../../services/ICustomerPortalService";

interface IParams {
    policyNumber: string
    invoiceId: string
    [key: string]: string | undefined
}

interface IState {
    premiumType?: string,
    dataLoaded: boolean,
    invoiceId: string;
}

@authorize
export class MissedPaymentPagePlain extends React.Component<IWithRouterProps<IParams>, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    private pluginTemplates = new PluginTemplates();
    private readonly paymentPaid: any;

    constructor(props: IWithRouterProps<IParams>) {
        super(props);
        this.paymentPaid = window.sessionStorage.getItem("paymentAmount");

        this.state = {
            dataLoaded: false,
            invoiceId: this.props.params?.invoiceId,
        };
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Payment");

        this.customerPortalService.getAnnualPolicyInfo(this.props.params.policyNumber)
            .subscribe((policy: AnnualPolicyInfo) => {
                const unpaidInstallmentIdToAmount: any = policy.unpaidInstallmentIdToAmount;

                // A bit of a workaround, ideally invoiceId should be populated in the props already. Raised FER-7186 to address
                if (!this.state.invoiceId && unpaidInstallmentIdToAmount && Object.keys(unpaidInstallmentIdToAmount).length > 0) {
                    this.setState({
                        invoiceId: Array.from(Object.keys(unpaidInstallmentIdToAmount))[0]
                    })
                }

                this.setState({
                    premiumType: policy.premiumType,
                    dataLoaded: true
                })
            })
    }

    public render() {
        const dataLoaded = this.state.dataLoaded;
        return (
            <React.Fragment>
                <Overlay show={!dataLoaded}/>
                <FalconHeader/>
                {dataLoaded && this.renderPageContents()}
                <Footer/>
            </React.Fragment>
        );
    }

    private getRedirectUrl = (): string => {
        return this.state.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY
            ? `/dashboard/monthlyPaymentHistory/${this.props.params.policyNumber}`
            : `/dashboard/annualPaymentHistory/${this.props.params.policyNumber}`;
    }

    private renderPageContents() {
        if (this.paymentPaid) {
            return <Navigate to={this.getRedirectUrl()}/>
        } else {
            return (
                <div className="plugin">
                    <FalconNavigatorHeader back={this.getRedirectUrl()} title="Payment"/>
                    <MissedPaymentForm
                        verifyNewCardFailed={this.props.location?.state?.verifyCardFailed}
                        policyNumber={this.props.params.policyNumber}
                        invoiceId={this.state.invoiceId}/>
                    {this.pluginTemplates.renderBackReloadLink("Back", false, this.getRedirectUrl())}
                </div>
            );
        }
    }
}

export const MissedPaymentPage = withRouter<{}, IParams>(MissedPaymentPagePlain)
